import React from "react";
import { Stack } from "@mui/material";

const FilterRow = ({ children, className, sx, ...props }) => {
  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      spacing={1.5}
      alignItems={{ xs: "stretch", md: "center" }}
      className={className}
      sx={{ mb: 1.5, ...sx }}
      {...props}
    >
      {children}
    </Stack>
  );
};

export default FilterRow;
